// The Industry choices everywhere: the suggestions plus any industry already
// typed on an account, so a new one shows up for the next account and in the
// Accounts "All industries" filter (Stephanie 2026-10-16).
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { industryOptions } from "@/lib/industries";

export function useIndustryOptions(): string[] {
  const q = useQuery({
    queryKey: ["clients", "industries"],
    queryFn: () => api<{ rows: Array<{ industry: string | null }> }>("/clients?limit=100"),
    staleTime: 60_000,
  });
  return industryOptions((q.data?.rows ?? []).map((r) => r.industry));
}
